<template>
  <div class="white elevation-3 rounded-sm grow">
    <v-row class="px-3">
      <v-col class="px-4" cols="6">
        <span class="text-h5 font-weight-medium">
          {{ $t("contract.show.main_panel.headers.payments") }}
        </span>
      </v-col>
      <v-col class="pr-4" cols="6">
        <div class="d-flex flex-row align-center justify-end">
          <v-btn
            @click="
              $router.push({
                name: 'CreateBuildingTax',
                id: building.id,
                query: {
                  objectType: 'Building'
                }
              })
            "
            :properties="building.properties"
            color="primary"
          >
            {{ $t("action.add_tax") }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <div
      class="px-4"
      v-if="building.taxes.length"
      v-for="tax in building.taxes"
    >
      <tax :tax="tax" class="mb-3" @reload="$emit('reload')"></tax>
    </div>
  </div>
</template>

<script>
import Tax from "@/components/taxes/Tax";

export default {
  props: {
    building: {
      required: true,
      type: Object
    }
  },

  components: { Tax }
};
</script>
